// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetRegionalConfigurationRequest from '../contract/GetRegionalConfigurationRequest';

export default function getRegionalConfigurationRequest(
    data: GetRegionalConfigurationRequest
): GetRegionalConfigurationRequest {
    const result: GetRegionalConfigurationRequest = {
        __type: 'GetRegionalConfigurationRequest:#Exchange',
        ...data,
    };

    return result;
}
